module.exports = __webpack_public_path__ + "09e00aa7622ece30a0f1e06b55f66c2a.eot";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-light.eot
// module id = 656
// module chunks = 0